  <template>
    <div class="control-section">
      <div class="h100vh-180">
        <ejs-grid ref='grid' :dataSource="data" height="calc(100% - 0px)"  :pageSettings="page" :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='66' textAlign='Center' ></e-column>
            <e-column field='imsi' :headerText='$t("LteUser.imsi")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='msisdn' :headerText='$t("LteUser.msisdn")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='imsi_status' :headerText='$t("LteUser.imsi_status")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='profile_id' :headerText='$t("LteUser.profile_id")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='imsi_odb' :headerText='$t("LteUser.imsi_odb")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='ipv4_addr' :headerText='$t("LteUser.ipv4_addr")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
            <!--<e-column field='ipv6_addr' :headerText='$t("LteUser.ipv6_addr")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>-->
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='qryUsers()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <CustomDialog ref='addUserPage' :element='dialog.element.eleAddUser' :styles='dialog.styles' :messages='dialog.messages.addUser'>
        <template v-slot:dialog-content>
          <AddUserForm ref="addUser" ></AddUserForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='addBatchUserPage' :element='dialog.element.eleAddBatchUser' :styles='dialog.styles' :messages='dialog.messages.addBatchUser'>
        <template v-slot:dialog-content>
          <AddBatchUserForm ref="addBatchUser" ></AddBatchUserForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='modUserPage' :element='dialog.element.eleModUser' :styles='dialog.styles' :messages='dialog.messages.modUser'>
        <template v-slot:dialog-content>
          <ModUserForm ref="modUser" ></ModUserForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='delRangePage' :element='dialog.element.eleDelRange' :styles='dialog.stylesDelRange' :messages='dialog.messages.delRange'>
        <template v-slot:dialog-content>
          <DelRangeUserForm ref="delRange" ></DelRangeUserForm>
        </template>
      </CustomDialog>
      <Notification ref='notification' :position='position' timeOut='2000' ></Notification>
      <DialogConfirm ref='dialogConfirm' :title='$t("SubscriberIms.reminder")' :content='$t("LteUser.delConfirm")' :onOk='onClickDelOk' ></DialogConfirm>
      <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
    </div>
  </template>
<script>

import { Reorder, Resize } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../../common/CustomDialog';
import Notification from "../../util/tipDialog/Notification";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddUserForm from './dialog/AddUserForm';
import AddBatchUserForm from './dialog/AddBatchUserForm';
import ModUserForm from './dialog/ModUserForm';
import DelRangeUserForm from './dialog/DelRangeUserForm';
import ajaxUrl from "../../data/ajaxUrl";
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: 'UserTable',
  components: {
    CustomDialog,
    Notification,
    DialogConfirm,
    AddUserForm,
    AddBatchUserForm,
    ModUserForm,
    DelRangeUserForm,
    DialogList,
  },
  data() {
    return {
      data: {},
      qryTypeFlag: 0,
      filterFlag: false,
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      ne: {
        neid: '',
        netype: '',
        neversion: '',
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          visible: false,
          model: true,
        },
        stylesDelRange: {
          width: '810px',
          height: 'auto',
          visible: false,
          model: true,
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddUser: {
            target: this.$refs.addUser,
            refName: 'eleAddUser',
            buttonGroup: [
              { click: this.closeAddUserPage, buttonModel: { content: this.$t("LteUser.cancel") } },
              { click: this.saveAddUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } }
            ],
            title: this.$t("LteUser.addUser"),
            isClose: true,
          },
          eleAddBatchUser: {
            target: this.$refs.addBatchUser,
            refName: 'eleAddBatchUser',
            buttonGroup: [
              { click: this.closeAddBatchUserPage, buttonModel: { content: this.$t("LteUser.cancel") } },
              { click: this.saveAddBatchUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } }
            ],
            title: this.$t("LteUser.addBatchUser"),
            isClose: true,
          },
          eleModUser: {
            target: this.$refs.modUser,
            refName: 'eleModUser',
            buttonGroup: [
              { click: this.closeModUserPage, buttonModel: { content: this.$t("LteUser.cancel") } },
              { click: this.saveModUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } }
            ],
            title: this.$t("LteUser.modUser"),
            isClose: true,
          },
          eleDelRange: {
            target: this.$refs.delRange,
            refName: 'eleDelRange',
            buttonGroup: [
              { click: this.closeDelRangePage, buttonModel: { content: this.$t("LteUser.cancel") } },
              { click: this.saveDelRangeUser, buttonModel: { content: this.$t("LteUser.confirm"), isPrimary: true } }
            ],
            title: this.$t("LteUser.delRange"),
            isClose: true,
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("LteUser.confirm") }
              }
            ],
            title: this.$t("LteUser.logger"),
            isClose: true,
          },
        },
        messages: {
          addUser: {
            title: this.$t("LteUser.addUser"),
          },
          addBatchUser: {
            title: this.$t("LteUser.addBatchUser"),
          },
          modUser: {
            title: this.$t("LteUser.modUser"),
          },
          delRange: {
            title: this.$t("LteUser.delRange"),
          },
        },
      },
      position: { X: 'Center', Y: 'Top' },
      imsiFilter: '',
      descImsiStatus: {
        0: this.$t("LteUser.GRANTED"),
        1: this.$t("LteUser.ODB"),
        2: this.$t("LteUser.DISABLED"),
      },
      descImsiODB: {
        1: this.$t("LteUser.odb_0"),
        2: this.$t("LteUser.odb_1"),
        4: this.$t("LteUser.odb_2"),
        6: this.$t("LteUser.odb_3"),
      },
    };
  },
  provide: {
      grid: [ Reorder, Resize ],
  },
  methods: {
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryUsers();
    },
    isChooseNe() {
      if (this.ne.neid === '') {
        //alert(this.$t("LteUser.pleaseSelectNE"));
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.pleaseSelectNE")});
        return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        //alert(this.$t("LteUser.pleaseSelectDatas"));
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.pleaseSelectDatas")});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        //alert(this.$t("LteUser.pleaseSelectOneData"));
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.pleaseSelectOneData")});
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const userId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        userId.push(checkedData[i].imsi);
      }
      return userId.length === 0 ? false : userId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal || !response.data.resultVal.length) {
        console.log("response.data.resultVal error");
        return true;
      }
      for (let i=0; i<response.data.resultVal.length; i++) {
        const item = response.data.resultVal[i];
        if (!item) {
          console.log("response.data.resultVal item error");
          return true;
        }
        if (!item.code || !item.code.length) {
          console.log("response.data.resultVal item.code error");
          return true;
        }
        if (item.code.length >= 2) {
          if (item.code.substr(item.code.length-2, 2) !== ".0") {
            EventBus.$emit('toast', {type: 'warning', content: item.display});
            return true;
          }
        }
      }
      return false;
    },
    openAddUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addUser.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
          //this.$refs.notification.error({ title: this.$t("LteUser.failed"), content: response.data.errorString });
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
          return;
        }
        this.$refs.addUserPage.show();
      });
    },
    closeAddUserPage() {
      this.$refs.addUserPage.clear();
      this.$refs.addUserPage.close();
    },
    saveAddUser() {
      this.$refs.addUser.saveUser(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddUserPage();
        //this.$refs.notification.success({ title: this.$t("LteUser.success"), content: this.$t("LteUser.addUserSuccess") });
        EventBus.$emit('toast', {type: 'success', content: this.$t("LteUser.addUserSuccess")});
        this.qryUsers();
      });
    },
    getKey(obj, value) {
      for(let key in obj){
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
    openModUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
         const record = checkedDatas.map((item) => {
          return {
            ...item,
            imsi_status: this.getKey(this.descImsiStatus, item.imsi_status),
            imsi_odb: this.getKey(this.descImsiODB, item.imsi_odb),
          }
        });
        this.$refs.modUser.getJson(this.ne, record, (response) => {
          if(response.data.errorCode !== "0") {
            //this.$refs.notification.error({ title: this.$t("LteUser.failed"), content: response.data.errorString });
            EventBus.$emit('toast', {type: 'warning', content:  response.data.errorString});
            return;
          }
          this.$refs.modUserPage.show();
        });
      }
    },
    closeModUserPage() {
      this.$refs.modUserPage.clear();
      this.$refs.modUserPage.close();
    },
    saveModUser() {
      this.$refs.modUser.saveUser(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeModUserPage();
        //this.$refs.notification.success({ title: this.$t("LteUser.success"), content: this.$t("LteUser.modUserSuccess") });
        EventBus.$emit('toast', {type: 'success', content:  this.$t("LteUser.modUserSuccess")});
        this.qryUsers();
      });
    },
    delUsers() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      const params = {
        vo: {
          imsis: delKeys,
          count: delKeys.length,
          bitmask: 2,
        },
        info: {
          msgid: "17063",
          neid: this.ne.neid,
        }
      };

      this.$axios.post(ajaxUrl.delLteUser, params).then(response => {
        if (!response) {
          console.log("onClickDelOk response error");
          return;
        }
        if (!response.data) {
          console.log("onClickDelOk response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("onClickDelOk response.data.resultVal null error");
          return;
        }
        const resultVal = response.data.resultVal;
        const operList = [];
        for (let i = 0; i < delKeys.length; i++) {
          operList.push({
            operObj: delKeys[i],
            operResult: resultVal[i] ? resultVal[i].display : '',
            operCode:resultVal[i] ? resultVal[i].code : ''
          });
        }
        this.$refs.dialogList.addOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delKeys.length);
        this.$refs.dialogListPage.show();
        this.qryUsers(undefined,undefined,true);
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    refreshData() {
      this.imsiFilter = '';
      this.filterFlag = false;
      this.qryUsers(0, true);
    },
    filterData() {
      this.filterFlag = true;
      this.qryUsers(2, true);
    },
    qryUsers(flag = undefined, prompt=false,delFlag = false) {
      if (flag === undefined) {
        flag = this.qryTypeFlag;
      } else {
        this.qryTypeFlag = flag;
      }
      this.page.pageNo = this.filterFlag ? 1 : this.$refs.pager.ej2Instances.currentPage;
      if (delFlag) {
         this.page.pageNo = 1;
      }
      this.filterFlag = false;
      const params = {
        vo: {
          flag: flag,
          imsi: (flag === 2) ? this.imsiFilter : '',
        },
        info: {
          msgid: "17064",
          neid: this.ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };
      this.$axios.post(ajaxUrl.qryLteUser, params).then((response) => {
        if (!response) {
          console.log("qryUsers response error");
          return;
        }
        if (!response.data) {
          console.log("qryUsers response.data error");
          return;
        }
        if (response.data.errorCode ===  'subscriber.9005') {
          this.ne.neid = '';
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          EventBus.$emit('toast', {type: 'warning', content: this.$t('MCS.neOffLine')});
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryUsers response.data.resultVal error");
          return;
        }
        if (response.data.resultVal.result !== 0) {
          console.log("qryUsers response.data.resultVal.result error");
          //this.$refs.notification.error({ title: this.$t("LteUser.failed"),  content: response.data.resultVal.result.toString() });
          EventBus.$emit('toast', {type: 'warning', content:  response.data.resultVal.result.toString()});
          return;
        }
        const res = response.data.resultVal;
        if (res) {
          if (res.resultlist) {
            const resultlist = res.resultlist.map(item => {
              // console.log('item', item)
              let ipv4_addr = '';
              let ipv6_addr = '';
              if (item.staAddrConfig) {
                item.staAddrConfig.map((item)=> {
                  if (item.ipv4_addr) {
                    ipv4_addr += item.ipv4_addr + ";"
                  }
                  if (item.ipv6_addr) {
                    ipv6_addr += item.ipv6_addr + ";"
                  }
                })
              }
              return {
                ...item,
                imsi_status: this.descImsiStatus[item.imsi_status],
                imsi_odb: this.descImsiODB[item.imsi_odb],
                ipv4_addr: ipv4_addr,
                ipv6_addr: ipv6_addr,
              }
            });
            this.data = resultlist;
          } else {
            this.data = [];
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countrsp;
          this.page.pageCount = Math.ceil(res.countrsp / this.page.pageSize);
        }
        if (prompt) {
          //this.$refs.notification.success({ title: this.$t("LteUser.success"), content: this.$t("LteUser.qryUserSuccess") });
          EventBus.$emit('toast', {type: 'success', content: this.$t("LteUser.qryUserSuccess")});
        }
        setTimeout(()=> {
          if (this.page.totalCount === 0) { // 没有数据---组件会将domtokenlist增加e-checkbox-disabled属性
            console.log(this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0]);
            const temp = this.$refs.grid.$el.childNodes[2].children[0].children[0].children[1].children[0].children[0].children[0].children[0].classList;
            if (temp.length > 2) {
              temp.remove('e-checkbox-disabled');
            }
          }
        }, 100);
      });
    },
    openAddBatchUserPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addBatchUser.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
          //this.$refs.notification.error({ title: this.$t("LteUser.failed"), content: response.data.errorString });
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
          return;
        }
        this.$refs.addBatchUserPage.show();
      });
    },
    closeAddBatchUserPage() {
      this.$refs.addBatchUserPage.clear();
      this.$refs.addBatchUserPage.close();
    },
    saveAddBatchUser() {
      this.$refs.addBatchUser.saveBatchUser(this.ne, (response, addUserList) => {
        this.closeAddBatchUserPage();
        if (!response) {
          console.log("saveBatchUser response error");
          return;
        }
        if (!response.data) {
          console.log("saveBatchUser response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("saveBatchUser response.data.resultVal error");
          return;
        }
        const resultVal = response.data.resultVal;
        const operList = [];
        for (let i = 0; i < addUserList.length; i++) {
          operList.push({
            operObj: addUserList[i].imsi,
            operResult: resultVal[i] ? resultVal[i].display : '',
            operCode:resultVal[i] ? resultVal[i].code : ''
          });
        }
        this.$refs.dialogList.addOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(addUserList.length);
        this.$refs.dialogListPage.show();
        this.qryUsers();
      });
    },
    openDelRangePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.delRangePage.show();
    },
    closeDelRangePage() {
      this.$refs.delRangePage.clear();
      this.$refs.delRangePage.close();
    },
    saveDelRangeUser() {
      if (!this.$refs.delRange.validate()) {
        return;
      }
      this.$loading.showLoadding(this.$t('LteUser.batchDelUserTip'),this.$t('SubscriberIms.waitTip'));
      this.$refs.delRange.delRangeUser(this.ne, (response, delUserList) => {
        this.closeDelRangePage();
        this.$loading.hideLoadding();
        if (!response) {
          console.log("qryUsers response error");
          return;
        }
        if (!response.data) {
          console.log("qryUsers response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryUsers response.data.resultVal error");
          return;
        }
        const resultVal = response.data.resultVal;
        const operList = [];
        for (let i = 0; i < delUserList.length; i++) {
          operList.push({
            operObj: delUserList[i].imsi,
            operResult: resultVal[i] ? resultVal[i].display : '',
            operCode:resultVal[i] ? resultVal[i].code : ''
          });
        }
        this.$refs.dialogList.addOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delUserList.length);
        this.$refs.dialogListPage.show();
        this.qryUsers(undefined,undefined,true);
      });
    },
    setfilter(params) {
      this.imsiFilter = params;
    },
  }
};
</script>

<style scoped>

</style>
